module.exports = __webpack_public_path__ + "img/104015.5551729d.png";